"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("@stardust-ui/react");
const React = require("react");
const AriaContext_1 = require("src/ts/contexts/AriaContext");
const ConfigContext_1 = require("../../contexts/ConfigContext");
const Footer_1 = require("../common/Footer");
const NestedStackNavigationView_1 = require("../common/NestedStackNavigationView");
const LoginMethod_1 = require("./login/LoginMethod");
class LoginView extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.renderThemeAware = (theme) => {
            return React.createElement("div", { className: 'loginView', style: { background: `linear-gradient(180deg, white -200%, ${theme.siteVariables.brand} 100%)` } },
                React.createElement("div", { className: 'body' },
                    React.createElement(ConfigContext_1.ConfigContextConsumer, null, (configContext) => React.createElement(react_1.Image, { className: 'logo', src: `${configContext.basePath}/images/icons/skypex-icon-white.png`, "aria-hidden": 'true' })),
                    React.createElement(AriaContext_1.AriaContextConsumer, null, (ariaContext) => React.createElement(NestedStackNavigationView_1.NestedStackNavigationView, { ariaContext: ariaContext, initialView: React.createElement(LoginMethod_1.LoginMethod, null), initialViewProps: { eventViewName: 'login-method' } }))),
                React.createElement(Footer_1.Footer, { dark: true }));
        };
    }
    render() {
        return React.createElement(react_1.ProviderConsumer, { render: this.renderThemeAware });
    }
}
exports.LoginView = LoginView;
